<template>
  <v-card width="100%">
    <v-list-item class="grow" v-if="report.reporter">
      <v-list-item-avatar color="grey darken-3">
        <v-img
          class="elevation-6"
          alt=""
          :src="
            report.reporter.avatar_permanent_url ||
              require('@/assets/images/default-profile.png')
          "
        ></v-img>
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title>
          <span v-if="report.reporter.full_name">{{
            report.reporter.full_name
          }}</span>
          <span v-else
            >{{ report.reporter.first_name }}
            {{ report.reporter.last_name }}</span
          ></v-list-item-title
        >
      </v-list-item-content>
    </v-list-item>
    <v-card-text>
      <span class="subtitle-1 font-weight-black">Subject:</span>
      {{ report.subject || '' }}
    </v-card-text>
    <v-card-text>
      <h1 class="subtitle-1 font-weight-black">Description:</h1>
      {{ report.description }}
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <Attachments
        v-if="report.attachments.length > 0"
        :attachments="report.attachments"
      />
    </v-card-actions>
  </v-card>
</template>
<script>
import Attachments from './Attachments.vue'
export default {
  props: {
    report: {
      type: Object,
      default: Object
    }
  },
  components: {
    Attachments
  },
  data: () => ({
    //
  })
}
</script>
